<template>
  <router-view />
</template>

<script>
import groupModule from '../../store/groups'
import customerModule from '../../store/customers'

export default {
  beforeCreate () {
    this.$store.registerModule('groups', groupModule)
    this.$store.registerModule('customers', customerModule)
  },
  destroyed () {
    this.$store.unregisterModule('groups')
    this.$store.unregisterModule('customers')
  }
}
</script>
